import { QuestionComponentProps } from "..";

import { VisaSponsorshipSelector } from "./components/VisaSponsorshipSelector";

export function VisaSponsorship({
  setNextEnabled,
}: QuestionComponentProps): React.ReactElement {
  return (
    <VisaSponsorshipSelector
      onPreferenceSet={(isPreferenceSet: boolean) =>
        setNextEnabled?.(isPreferenceSet)
      }
    />
  );
}
